export default __webpack_public_path__ + "static/media/BASE_TECNOLOGIA_RR_310_MANEJO_01.fa09c0ec.jpg";